import { SVGProps, Ref, forwardRef } from 'react';

export const LockClosedOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.978 3.09c-.09-.478-.23-.903-.421-1.247C7.223 1.242 6.751.9 6 .9s-1.223.342-1.557.943c-.191.344-.33.769-.42 1.247C4.561 3.022 5.212 3 6 3c.786 0 1.438.022 1.978.09M6 0C4.157 0 3.32 1.51 3.078 3.294 1.749 3.754 1.5 4.879 1.5 7.5c0 3.938.563 4.5 4.5 4.5s4.5-.562 4.5-4.5c0-2.621-.25-3.747-1.578-4.206C8.68 1.51 7.843 0 6 0M2.534 5.302C2.436 5.821 2.4 6.522 2.4 7.5c0 .977.036 1.68.134 2.198.096.51.236.752.376.892s.383.28.892.376c.519.098 1.22.134 2.198.134.977 0 1.68-.036 2.198-.134.51-.096.752-.236.892-.376s.28-.383.376-.892c.098-.519.134-1.22.134-2.198 0-.977-.036-1.68-.134-2.198-.096-.51-.236-.752-.376-.892s-.383-.28-.892-.376C7.679 3.936 6.978 3.9 6 3.9c-.977 0-1.68.036-2.198.134-.51.096-.752.236-.892.376s-.28.383-.376.892M5.55 8.75h.9v-2.5h-.9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LockClosedOutlinedSize12Glyph.displayName = 'LockClosedOutlinedSize12Glyph';
